import React from 'react';
import { V } from '../../common/Layout';
import { DataListCellProvider } from '../DataList/DataListCellContext';
import ProductionHeaderDataGrid from './ProductionHeaderDataGrid';
import { ProductionCardViewProps } from './productionHeaderUtils';

export type ProductionDetailsPanelBodyProps = Pick<ProductionCardViewProps, 'viewState' | 'statusNote'>;

export default function ProductionDetailsPanelBody({ viewState, statusNote }: ProductionDetailsPanelBodyProps) {
    return (
        <V sx={{ overflowY: 'auto' }}>
            <DataListCellProvider isNotesPanelOpen={false} openPanelType={null}>
                <ProductionHeaderDataGrid
                    viewState={viewState}
                    isReadOnly
                    sidePanelView
                    statusNote={statusNote}
                />
            </DataListCellProvider>
        </V>
    );
}
